import styled from 'styled-components'
import Button from '@sl/ui-library/molecules/Button'

export const StyledBrandingButton = styled(Button)`
  &:not(:disabled) {
    background-color: #ff550b;
    &:hover {
      background-color: #ffa422;
    }
  }
`

export const StyledFormContainer = styled.div`
  background-color: #f5f7fa;
  text-align: left;

  @media screen and (max-width: 768px) {
    margin: 28px auto 0;
    width: 100%;
  }
`

export const StyledTitle = styled.h2`
  font-size: 24px;
  padding: 1.5rem;
  margin: 0;

  @media screen and (max-width: 780px) {
    margin: 0 auto;
    padding: 0.75rem;
    text-align: left;
  }
`

export const StyledFormContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`

export const StyledProperty = styled.div`
  display: flex;
  font-size: 1rem;
  justify-content: left;
  margin-bottom: 0;
  padding: 0.75rem 1.5rem 1.5rem 1.5rem;
  width: 100%;

  p {
    padding: 0;
    margin: 0;
  }

  label {
    margin: 0 0.75rem;
    display: flex;
    align-items: flex-start;

    input {
      margin: 0.3rem;
    }
  }

  @media screen and (max-width: 780px) {
    font-size: 1rem;
    padding: 0.75rem 0.75rem 1.5rem;
  }
`
export const StyledInput = styled.div`
  padding: 0 1.5rem 0.875rem 1.5rem;
  width: 100%;

  label {
    left: 0;
  }

  @media screen and (max-width: 780px) {
    padding: 0 0.75rem 0.75rem 0.75rem;
  }
`

export const StyledLegal = styled.div`
  padding: 0 0.875rem 0 0.875rem;
  width: 100%;

  @media screen and (max-width: 780px) {
    padding: 0 0.75rem 1rem 0.75rem;
  }
`

export const StyledCTA = styled.div`
  padding: 1.5rem 1.5rem 0.875rem 1.5rem;
  width: 100%;
  text-align: center;

  button {
    text-align: center;
    cursor: pointer;
  }

  @media screen and (max-width: 780px) {
    padding: 0 0.75rem 0.75rem 0.75rem;
  }
`

export const StyledFooterForm = styled.div`
  font-size: 0.75rem;
  margin: 0.875rem 0 0 0;
  padding: 0.875rem 1.5rem 0 1.5rem;
  border-radius: 4px;
  width: 100%;

  @media screen and (max-width: 780px) {
    padding: 0.75rem;
    p {
      padding: 0;
    }
  }
`

export const StyledError = styled.p`
  color: #ff3c54;
  font-size: 0.75rem;
  padding: 0 1.5rem 0.875rem 1.5rem;
  display: ${props => (props.display ? 'inline-block' : 'none')};
  width: 100%;

  @media screen and (max-width: 780px) {
    text-align: left;
    padding: 0 0.75rem 0.875rem 0.75rem;
  }
`

export const LogoBrasContainer = styled.div`
  display: flex;
  padding: 24px 24px 0px;
  justify-content: center;

  @media screen and (max-width: 780px) {
    padding: 12px;
  }
`
